import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15.998 20.066a9 9 0 1 0 -3.998 .934v-13","key":"svg-0"}],["path",{"d":"M16 12l-4 -4l-4 4","key":"svg-1"}]]

const IconCircleOpenArrowUp = createReactComponent('outline', 'circle-open-arrow-up', 'CircleOpenArrowUp', __iconNode);

export default IconCircleOpenArrowUp;